<template>
  <div id="tTtabBar">
    <div v-for="(item, index) in typeList" :key="index" :index="index + ''">
      <div v-if="index == currentSelectedIndex" :style="{height:itemHeight+'vh'}" style="display:flex;align-items: Center; justify-content: center;display: flex;flex-direction: column;" @click="clickIndex(index)">
        <img v-if="item['typename'] == '我的'" src="~assets/img/SdkV3/MineSelected.png" style="width:25px;height:28px;vertical-align: middle;object-fit: scale-down;" />
        <img v-else src="~assets/img/SdkV3/ActivitySelected.png" style="width:25px;height:28px;vertical-align: middle;object-fit: scale-down;" />
        <span style="font-size:xx-small;color:#F84925;transform: scale(0.9);"> {{ item['typename'] }}</span>
      </div>
      <div v-else :style="{height:itemHeight+'vh'}" style="display:flex;align-items: Center; justify-content: center; display: flex;flex-direction: column;" @click="clickIndex(index)">
        <img v-if="item['typename'] == '我的'" src="~assets/img/SdkV3/MineUnSelected.png" style="width:25px;height:28px;vertical-align: middle;object-fit: scale-down;" />
        <img v-else src="~assets/img/SdkV3/ActivityUnSelected.png" style="width:25px;height:28px;vertical-align: middle;object-fit: scale-down;" />
        <span style="font-size:xx-small;color:#B4B4B4;transform: scale(0.9);"> {{ item['typename'] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default { 
  props: {
    typeList: [],
    itemHeight: "",//每个选项的高度
  },
  data() {
    return {
      currentSelectedIndex: 0,
    }
  },
  components: {
  },
  methods: {
    close() {
      this.sendToClient('close?')
    },
    clickIndex(index){
      if(index == this.currentSelectedIndex)return
      this.currentSelectedIndex = index
      let selectedItem = this.typeList[index]
      this.$emit("clickitem", selectedItem)
    }
  }
}
</script>

<style>
/* div {
  background-color: bisque;
}
router-view{
  background-color: red;
} */

#tTtabBar {
  background-color: #FFF3F3;
  flex-direction: column;
  width: 15vw;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/TabBar.vue